import Summary from "./index";
import Others from "./others";
import SelfIntroduction from "./selfIntroduction";
import Projects from "./projects";
import {useEffect, useRef} from "react";
import {useVersionContext} from "../../context/GlobalContext";

const AllSummary = () => {
    const {getVersion} = useVersionContext();
    const activeTarget = 'choice-summary-4';
    const focusRef = useRef();
    useEffect(() => {
        document.querySelector(`#${activeTarget}`)?.classList?.add('border-primary');
        focusRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    },[])

    return (<>
        {getVersion() === 1 && (
            <>
                <Summary/>
                <div ref={focusRef}>
                    <Others allMode/>
                    <SelfIntroduction allMode/>
                    <Projects allMode/>
                </div>
            </>
        )}
    </>);
}

export default AllSummary;